import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { FormGroup, ListGroup } from 'react-bootstrap'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import Alert from '@severed-links/common.alert'
import Modal from '@severed-links/common.modal'
import TextInput from '@severed-links/common.text-input'
import { createNotification } from '@severed-links/common.redherrings-reducers/notifications'
import { login, getMe } from '@severed-links/common.redherrings-reducers/account'
import { contestRegistration } from '@severed-links/common.redherrings-reducers/main'
import * as s from './RegisterContest.scss'

const RegisterContest = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { userName, roles } = useSelector(state => state.account)
    const [passphrase, setPassphrase] = useState('')
    const [password, setPassword] = useState('')
    const [isLoggingIn, setLoggingIn] = useState(false)

    const reLogin = () => {
        dispatch(login(userName, password))
        .then(action => {
            if (action.payload.access_token) {
                setLoggingIn(false)
                setPassword('')
                setPassphrase('')
                dispatch(getMe())
                .then(() => {
                    navigate('/main')
                })
            } else {
                dispatch(createNotification({ type: 'error', 
                    headline: 'Contest Registration -- Re-Login', 
                    message: 'Incorrect password', 
                    timeout: 6000
                }))
            }
        })
    }

    const checkPassphrase = () => {
        dispatch(contestRegistration(passphrase))
        .then(action => {
            dispatch(createNotification({ type: action.payload.messageType, 
                headline: 'Contest Registration', 
                message: action.payload.message, 
                timeout: 6000
            }))
            if (action.payload.messageType === 'success') {
                setLoggingIn(true)
            } else if (action.payload.messageType === 'info') {
                navigate('/main')
            }
        })
    }

    const registeredContests = (roles || [])
        .filter(role => role.indexOf('Player') > -1)
        .map(role => role.replace('Player', ''))

    return (
        <div className={s.container}>
            <section className={s.hero}>
                <div className={s.heroIcon}><FontAwesomeIcon name='key' /></div>
                <div>
                    <div className={s.eyebrow}>REDHERRINGS</div>
                    <h2>Register for a contest</h2>
                    <p>Enter a contest passphrase to add access to your account.</p>
                </div>
            </section>

            <section className={s.contentGrid}>
                <div className={s.panel}>
                    <div className={s.panelHeader}>
                        <div>
                            <h3>Your contests</h3>
                            <p>{registeredContests.length} registered</p>
                        </div>
                        <span className={s.countBadge}>{registeredContests.length}</span>
                    </div>

                    <ListGroup className={s.contestList}>
                        {registeredContests.map(contest =>
                            <ListGroup.Item className={s.contestItem} key={contest}>
                                <span className={s.contestIcon}><FontAwesomeIcon name='check' /></span>
                                <span>{contest}</span>
                            </ListGroup.Item>
                        )}
                        {!registeredContests.length ?
                            <ListGroup.Item className={s.contestItem}>
                                <span className={s.contestIcon}><FontAwesomeIcon name='info-circle' /></span>
                                <span>No contests located.</span>
                            </ListGroup.Item>
                        : null}
                    </ListGroup>
                </div>

                <div className={s.panel}>
                    <div className={s.panelHeader}>
                        <div>
                            <h3>Contest passphrase</h3>
                            <p>Use the passphrase provided by the contest administrator.</p>
                        </div>``
                    </div>

                    <FormGroup size='lg' className={s.formGroup}>
                        <TextInput name='passphrase' value={passphrase || ''}
                            icon='lock' autoCapitalize='none' autoFocus
                            required isValid={passphrase && passphrase.length > 3}
                            showValidState onChange={_text => setPassphrase(_text)}
                            label='Enter contest passphrase...'
                            buttonProps={{ variant: 'primary', icon: 'check', title: 'register', onClick: () => checkPassphrase(), disabled: !passphrase || passphrase.length <= 3 }} />
                    </FormGroup>

                    <Alert className={s.infoAlert} small variant='info' icon='info-circle' message={<div><strong>Note:</strong> You will be asked to enter your password after a successful contest registration to obtain new permissions.</div>} />
                </div>
            </section>

            <Modal heading='Enter your password'
                show={isLoggingIn}
                onClose={() => setLoggingIn(false)}
                actionButtonText={null}>
                <FormGroup className={s.modalFormGroup}>
                    <TextInput type='password' name='password' 
                        value={password || ''}
                        autoFocus autoCapitalize='none'
                        label='[Re-enter your password...]'
                        onChange={_text => setPassword(_text)}
                        buttonProps={{
                            variant: 'primary',
                            icon: 'check',
                            title: 're-login',
                            disabled: !password || password.length <= 3,
                            onClick: () => reLogin(),
                        }} />
                </FormGroup>
            </Modal>
        </div>
    )
}

export default RegisterContest
